import styled from 'styled-components';

const FailedWrapper = styled.div`
.payment-details-wrapper{
    color: #4c565c;
    margin: 0 auto;
    padding: 3rem;
    text-align: center;
    img{
      margin-bottom: 2rem;
      height: 100px;
    }
    h2{
      font-size: 2.25rem;
      font-weight: bold;
      margin-bottom: 1.25rem;
    }
    p{
      font-size: 1.75rem;
      margin-bottom: 1.75rem;

    }
}
a{
  display: inline-block;
  color: #6d43f0;
  text-decoration: none;
  font-size: 1.25rem;
  border: 1px solid #6d43f0;
  padding: 1rem;
  border-radius: 0.5rem;
  margin : 2.5rem 0 1rem;
}
`;

export default FailedWrapper;